import type { FilterChange } from '@/app/components/hotel-detail/changeTransport/ChangeTransportFiltersCommon';

/**
 * Accumulated, not-yet-applied filter changes of the open Evo filter popover.
 * `newState` is the merge of the `newState` slices of every staged change;
 * `event` is the event of the last staged change.
 */
export type EvoDraftFilterChange = {
  newState: Partial<TransportFiltersResponse> | undefined;
  event: FilterChange['event'];
};

export function mergeEvoDraftFilterChange(
  draft: EvoDraftFilterChange | null,
  filterChange: FilterChange
): EvoDraftFilterChange {
  return {
    newState: { ...draft?.newState, ...filterChange.newState },
    event: filterChange.event,
  };
}
